//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @event selector-click - 点击选择器触发的事件
 */
/* eslint-disable */

/**
 * @noteType component
 * @name TextSelect
 * @tagName mt-text-select
 * @desc 文本域(带选项)
 * @wrapClassName mint-text-select
 * @html
 * <mt-text-select label="标题文字"></mt-text-select>
 */
export default {
  name: 'mt-text-select',
  props: {
    value: { default: '' },
    // url: { type: String, default: '' },
    /**
       * @noteType prop
       * @field rows
       * @desc 行数
       * @type input
       * @value 4
       */
    rows: String,
    /**
       * @noteType prop
       * @field rows
       * @desc 行数
       * @type input
       * @value 100
       */
    maxlength: String,
    /**
     * @noteType prop
     * @field label
     * @desc 标题
     * @type input
     * @value 标题
     */
    label: { type: String, required: true },
    /**
     * @noteType prop
     * @field placeholder
     * @desc 占位文本
     * @type input
     * @value 请选择
     */
    placeholder: { type: String, default: '请选择' },
    /**
     * @noteType prop
     * @field options
     * @desc 选项字典数据
     * @type textarea
     * @value
     */
    options: { type: Array, required: true },
    disabled: Boolean,
    readonly: Boolean,
    attr: Object,
    required: Boolean,
    titlewidth: String,
    valueAlign:String
  },
  data() {
    return {
      selectorShow: false,
      currentValue: ""
    };
  },
  watch: {
    attr: {
      immediate: true,
      handler(attrs) {
        this.$nextTick(() => {
          const target = [this.$refs.input, this.$refs.textarea];
          target.forEach(el => {
            if (!el || !attrs) return;
            Object.keys(attrs).map(name => el.setAttribute(name, attrs[name]));
          });
        });
      }
    }
  },
  computed: {
    cHeight () {
      return document.documentElement.clientHeight
    }
  },
  methods: {
    handleDisplayClick(e) {
      if (this.disabled || this.readonly) return;
      this.$emit('selector-click', e)
      history.pushState('', null, '#/smile-select');
      this.selectorShow = true;
    },
    historyChange(e) {
      this.selectorShow = false;
    },
    selectOption(opt){
      if(opt.active){
        opt.active = false;
        let currentValueArray = this.currentValue.split('，');
        let _index = currentValueArray.indexOf(opt.name);
        currentValueArray.splice(_index,1);
        if(currentValueArray.length){
          this.currentValue = currentValueArray.join("，");
        }else{
          this.currentValue = "";
        }
      }else{
        opt.active = true;
        this.currentValue += this.currentValue?"，" + opt.name:opt.name;
      }
      this.$emit('input', this.currentValue);
    },
    singleSelectDisplay () {
      if (this.value === ''){
        this.options.forEach(function(value){
          value.active=false;
        });
        return this.placeholder
      }else{
        let valueArray = this.value.split('，');
        for(let i=0;i<valueArray.length;i++){
          for(let j=0;j<this.options.length;j++){
            if(valueArray[i]===this.options[j].name){
              this.options[j].active=true;
            }
          }
        }
      }
      if (this.options.length === 0) {
        this.$emit('selector-click', e)
        return ''
      }
      return this.currentValue;
    }
  },
  mounted () {
    window.addEventListener("popstate", this.historyChange)
  },
  beforeDestroy () {
    window.removeEventListener("popstate", this.historyChange)
  }
};

/**
 * @noteType external
 * @content
{
   "mock": {
      "label": "文本域",
      "rows": "4",
      "maxlength": "100"
   },
   "xtype": [ "text-select" ],
   "bindField": "v-model"
}
 */



// WEBPACK FOOTER //
// ./packages/text-select/src/text-select.vue